module.exports = __webpack_public_path__ + "img/logobalabs.b2469273.png";